"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getColor = function (colors, color) {
    if (color in colors) {
        return colors[color];
    }
    return color;
};
exports.default = (function (_a) {
    var _b = _a.theme, colors = _b.colors, darkDefaults = _b.darkDefaults, isDark = _b.dark, color = _a.color;
    if (!color) {
        return '';
    }
    if (typeof color === 'string') {
        return getColor(colors, color);
    }
    if (typeof color !== 'object') {
        return '';
    }
    var dark = color.dark, light = color.light;
    // TODO: revisit color definition type to avoid null assertion here in light
    return getColor(colors, isDark ? (dark || darkDefaults[light]) : light);
});
